import { useEffect, useState } from 'react';

// useCompetitorTargeting is the glue between the competitor-target
// window events and the surfaces that render player hotels
// (CompetitorsWindow on desktop, the competitor-grid in Game2d on
// mobile). It is a stand-alone subsystem: it owns its own dedicated
// event channel ('highlight-competitors-event' /
// 'clear-competitors-highlight-event') and does NOT piggyback on the
// docks / tradelanes / discard highlight channels. The dispatchers are
// the Ghost target mount and the Advertisement orbit click; both also
// keep their existing target swipers, so this is purely an additive
// second input affordance on the same target-pick step.
export function useCompetitorTargeting() {
    const [state, setState] = useState({
        playerIds: [],
        callback: null,
    });

    useEffect(() => {
        const onHighlight = (e) => {
            setState({
                playerIds: e.detail.playerIds || [],
                callback: e.detail.callback || null,
            });
        };
        const onClear = () => {
            setState({ playerIds: [], callback: null });
        };
        window.addEventListener(
            'highlight-competitors-event', onHighlight);
        window.addEventListener(
            'clear-competitors-highlight-event', onClear);
        return () => {
            window.removeEventListener(
                'highlight-competitors-event', onHighlight);
            window.removeEventListener(
                'clear-competitors-highlight-event', onClear);
        };
    }, []);

    const isTargetCandidate = (playerId) =>
        state.playerIds.includes(playerId);

    const onTargetClick = (playerId) => {
        if (typeof state.callback === 'function'
            && isTargetCandidate(playerId)) {
            state.callback(playerId);
        }
    };

    const hasCandidates = state.playerIds.length > 0;

    return { isTargetCandidate, onTargetClick, hasCandidates };
}

export default useCompetitorTargeting;
